import { ErrorHandler, NgModule } from '@angular/core';
import { provideStore, StoreModule } from '@ngrx/store';
import { QuillModule } from 'ngx-quill';

import { ApiCoreModule, ApiCoreService } from '@qtek/core/api-core';
import {
  LocalStorageManagementModule,
  LocalStorageManagementService,
} from '@qtek/core/local-storage-management';
import {
  ThemeManagementModule,
  ThemeManagementService,
} from '@qtek/core/theme-management';
import {
  WebsocketsCoreModule,
  WebSocketService,
} from '@qtek/core/websockets-core';
import { DialogLoaderModule } from '@qtek/libs/dialog-loader';
import { HealthcheckCoreModule } from '@qtek/libs/healthcheck-core';
import { HttpInterceptorsModule } from '@qtek/libs/http-interceptors';
import { MetaCoreModule } from '@qtek/libs/meta-core';
import { PermissionsModule } from '@qtek/libs/permissions';
import { metaReducers, REDUCERS, STORE_PROVIDERS } from '@qtek/libs/store';
import {
  TranslationCoreModule,
  TranslationCoreService,
} from '@qtek/libs/translation-core';

import { QtErrorHandler } from './error-handler';
import { APP_INITIALIZER_PROVIDERS } from './init';
import { INTL_PROVIDERS } from './intl';
import { LoaderComponent } from './loader/loader.component';

/**
 * This NgModule is core of **every** portal, it contains providers that will be used in every app.
 * Each portal should create its own core module based on this(to add additional providers etc).
 */
@NgModule({
  imports: [
    StoreModule.forRoot(REDUCERS, { metaReducers }),
    HttpInterceptorsModule,
    LocalStorageManagementModule,
    ApiCoreModule,
    PermissionsModule,
    TranslationCoreModule,
    WebsocketsCoreModule,
    HealthcheckCoreModule,
    MetaCoreModule,
    ThemeManagementModule,
    DialogLoaderModule,
    LoaderComponent,
    QuillModule.forRoot(),
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: QtErrorHandler,
    },
    ...APP_INITIALIZER_PROVIDERS,
    ...STORE_PROVIDERS,
    ...INTL_PROVIDERS,
    provideStore(REDUCERS, { metaReducers }),
    WebSocketService,
    ApiCoreService,
    LocalStorageManagementService,
    ThemeManagementService,
    TranslationCoreService,
  ],
})
export class QtCoreModule {}
